<template>
  <div>
    <h2 class="text-center">Formulario de ETMI</h2>

    <h4 class="text-center">Estrategia nacional para la eliminación de la transmisión materno - infantil</h4>

    <form @submit.prevent="submitForm" class="needs-validation">

      <div class="row">
        <div class="col-md-4">
      <div class="form-group">
        <label for="nombre">Nombre del trimestre:</label>
        <select id="nombre" v-model="formData.nombre" class="form-control" required>
          <option v-for="trimestre in etmitrimestres" :key="trimestre._id" :value="trimestre.trimestre">{{ trimestre.trimestre }}</option>
        </select>
        <div class="invalid-feedback">Este campo es obligatorio.</div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group">
        <label for="vacuna">Nombre Enfermedad:</label>
        <select id="vacuna" v-model="currentTamizaje.vacuna" class="form-control" required>
          <option v-for="vacuna in etmivacunas" :key="vacuna._id" :value="vacuna.vacuna">{{ vacuna.vacuna }}</option>
        </select>
      </div>
    </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="fechaRealizacion">Fecha de Realización:</label>
            <input type="date" id="fechaRealizacion" v-model="currentTamizaje.fechaRealizacion" class="form-control" required />
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="resultado">Resultado (reactivo/no reactivo):</label>
            <select id="resultado" v-model="currentTamizaje.resultado" class="form-control" required>
              <option value="">Seleccionar...</option>
              <option value="reactivo">Reactivo</option>
              <option value="no reactivo">No Reactivo</option>
            </select>
          </div>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <label for="semanaGestacion">Semana de Gestación:</label>
            <input type="number" id="semanaGestacion" v-model="currentTamizaje.semanaGestacion" class="form-control" min="1" max="42" required />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <button type="submit" class="btn btn-primary">Guardar</button>
        </div>
      </div>
    </form>
    <div class="table-responsive">
      <h2 class="text-center">Registros de ETMI para la Mujer</h2>
      <table class="table">
        <thead>
          <tr>
            <th>Nombre del Trimestre</th>
            <th>Nombre de la Enfermedad</th>
            <th>Fecha de Realización</th>
            <th>Resultado</th>
            <th>Semana de Gestación</th>
            <th>Eliminar</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(registro, index) in registrosETMI" :key="index">
            <td>{{ registro.nombre || 'N/A' }}</td>
            <td>{{ registro.tamizajes[0].vacuna || 'N/A' }}</td>
            <td>{{ registro.tamizajes[0].fechaRealizacion ? registro.tamizajes[0].fechaRealizacion.slice(0, 10) : 'N/A' }}</td>
            <td>{{ registro.tamizajes[0].resultado || 'N/A' }}</td>
            <td>{{ registro.tamizajes[0].semanaGestacion || 'N/A' }}</td>
            <td>
              <button @click="confirmarEliminarETMI(index)" class="btn btn-danger small">
                <font-awesome-icon icon="trash" class="small" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import swal from 'sweetalert';
import { BASE_URL } from '../store/config';

export default {
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
  props: {
    mujerId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      registrosETMI: [],
      message: '',
      formData: {
        nombre: '',
        tamizajes: [] ,
        mujerId: this.mujerId, 
      },
      currentTamizaje: {
      vacuna: '',
      fechaRealizacion: null,
      resultado: '',
      semanaGestacion: null,
    },
    etmitrimestres:[],
    etmivacunas: []
    };
  },
  methods: {
    submitForm() {
      this.formData.tamizajes = [this.currentTamizaje];
      axios.post(`${BASE_URL}/api/etmi`, this.formData, {
        headers: {
          'x-access-token': this.$store.state.auth.user.accessToken,
        },
      })
      .then(() => {
        swal({
          title: '¡Información Guardada!',
          text: 'La información de ETMI ha sido guardada correctamente.',
          icon: 'success',
          button: 'OK',
        });

        this.cargarRegistrosETMI();
        this.limpiarCampos();
    
      })
      .catch(error => {
        
        swal({
          title: 'Error',
          text: 'Hubo un error al guardar la información de ETMI.',
          icon: 'error',
          button: 'OK',
        });
      });
    },
    limpiarCampos() {
      this.currentTamizaje= {
      vacuna: '',
      fechaRealizacion: null,
      resultado: '',
      semanaGestacion: null,
    };
    this.formData = {
        nombre: '',
        tamizajes: [] ,
        mujerId: this.mujerId, 
      };
    },  
    cargarRegistrosETMI() {
      axios
      .get(`${BASE_URL}/api/etmi?mujerId=${this.mujerId}`, {
          headers: {
            'x-access-token': this.$store.state.auth.user.accessToken,
          },
        })
        .then(response => {
          this.registrosETMI = response.data;
        })
        .catch(error => {
          console.error('Error al cargar registros ETMI:', error);
        });
    },
    confirmarEliminarETMI(index) {
    const registro = this.registrosETMI[index];
    swal({
      title: '¿Estás seguro?',
      text: 'Una vez eliminado, no podrás recuperar este registro.',
      icon: 'warning',
      buttons: ['Cancelar', 'Eliminar'],
      dangerMode: true,
    }).then((confirmacion) => {
      if (confirmacion) {
        // Si el usuario confirma, llamar al método de eliminación
        this.eliminarRegistroETMI(registro._id);
      }
    });
  },
  async eliminarRegistroETMI(registroId) {
    try {
      const response = await axios.delete(`${BASE_URL}/api/etmi/${registroId}`, {
        headers: {
          'x-access-token': this.$store.state.auth.user.accessToken,
        },
      });

      swal('Éxito', response.data.message, 'success');
      this.cargarRegistrosETMI();
    } catch (error) {
      console.error('Error al eliminar el registro ETMI:', error);
      swal('Error', 'Hubo un error al eliminar el registro ETMI.', 'error');
    }
  },
  async fetchETMItrimestres() {
        try {
          const response = await axios.get(`${BASE_URL}/api/etmitrimestre`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.etmitrimestres = response.data;
        } catch (error) {
          console.error('Error al obtener ETMItrimestres:', error);
        }
     },
     async fetchETMIVacunas() {
        try {
          const response = await axios.get(`${BASE_URL}/api/etmivacuna`, {
            headers: {
              'x-access-token': this.$store.state.auth.user.accessToken,
            },
          });
          this.etmivacunas = response.data;
        } catch (error) {
          console.error('Error al obtener ETMIVacunas:', error);
        }
      },
  },
  
  mounted() {
    this.cargarRegistrosETMI();
    this.fetchETMItrimestres();
    this.fetchETMIVacunas();
  },
};
</script>

<style scoped>
/* Estilos adicionales si es necesario */
</style>
